export default __webpack_public_path__ + "static/media/lp-sec05_bg830.17a73285.png";